import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { Switch, Route } from "react-router-dom";
import isNotNull from "sprout-lib/dist/isNotNull";
import { featureRoutes } from "@sprout/client-routes";
import AppBarLanding from "./AppBarLanding";
import AppBarApp from "./AppBar_App";
const AppBar = ()=>{
    const currentUser = useCurrentUser();
    const businessPages = useMemo(()=>{
        return [
            !currentUser ? "/" : null,
            "/(terms|privacy|copyright|trademark|community)",
            "/amendment-to-sprout-terms-of-service-applicable-to-u-s-government-users",
            "/pricing",
            ...featureRoutes,
            "/features", 
        ].filter(isNotNull);
    }, [
        currentUser
    ]);
    return /*#__PURE__*/ _jsxs(Switch, {
        children: [
            /*#__PURE__*/ _jsx(Route, {
                exact: true,
                path: businessPages,
                children: /*#__PURE__*/ _jsx(AppBarLanding, {})
            }),
            /*#__PURE__*/ _jsx(Route, {
                exact: true,
                path: "*",
                children: /*#__PURE__*/ _jsx(AppBarApp, {})
            })
        ]
    });
};
export default AppBar;
